module.exports = __webpack_public_path__ + "img/iconBussinessOrderVerify.692a6eda.svg";